module.exports = __webpack_public_path__ + "static/media/comet.5c7b7498.svg";


//////////////////
// WEBPACK FOOTER
// ../core/src/assets/comet/comet.svg
// module id = 8
// module chunks = 0